export default __webpack_public_path__ + "static/media/check-circle-o.3794263e.svg";